// extracted by mini-css-extract-plugin
module.exports = {"start":"Start_start__19xiz","start_btn":"Start_start_btn__3nLy9"};